import {useTranslation} from "react-i18next";
import {Consts} from "../../pages/consts";
import TimeIntake from "./TimeIntake";

const TimeIntakes = ({timingType, intakes, onSetIntake, onAddNewRow}) => {
  const {t} = useTranslation();

  const notDefinedIntakes = intakes?.filter(intake => (!isNaN(intake?.dosage) && intake?.dosage === 0)
    || intake?.intakeTime === "");

  const addNewRow = () => {
    if (intakes?.length > 0 && notDefinedIntakes?.length <= 0) {
      onAddNewRow({ intakeTime: "", dosage: 0, dosageUnit: intakes[0]?.dosageUnit });
    }
  };

  return (
    <section className="time-intakes">
      { timingType === Consts.TIMES &&
        <div className="time-intakes__content">
          <div className="time-intakes__list">
            { intakes?.map((intake, i) => {
              return (
                <div className="time-intakes__item" key={ `intake${ i }` }>
                  <TimeIntake
                    index={ i }
                    intake={intake}
                    onSetIntake={onSetIntake}
                  />
                </div>
              );
            }) }
          </div>
          <div className="time-intakes__footer">
            <button
              className={
                notDefinedIntakes?.length <= 0
                  ? "w3-btn w3-round-xlarge w3-theme-d5 time-intakes__add-button"
                  : "w3-btn w3-round-xlarge w3-theme-d5 w3-disabled time-intakes__add-button"
              }
              onClick={ addNewRow }
              disabled={ notDefinedIntakes?.length > 0 }
            >
              + { t("add_new_row") }
            </button>
          </div>
        </div>
      }
    </section>
  );
};

export default TimeIntakes;
